// English (base) string catalog for the operator console.
//
// Sprint C PR (ae): scaffold. Migration is opt-in per component — net-new
// strings should land here first; existing hardcoded strings migrate as
// components are touched. The `t` helper in `./index.ts` is the single
// import target.
//
// Adding a locale:
//   1. Copy `en.ts` → `es.ts`, translate values keeping keys identical.
//   2. Re-export from `./index.ts` based on a future `navigator.language`
//      lookup (or operator settings drawer when account-prefs ship).
//   3. Strings reference each other via the `t.path.to.key` dot-path.

export const en = {
  notFound: {
    eyebrow: '404',
    heading: 'Page not found',
    // T-0221 (packet 007, D16) — plain words, no dev register ("operator-console").
    bodyTemplate: "The URL {path} doesn't match any page.",
    hint: 'Check the link — or head back to Tizok.',
    backCta: 'Back to Tizok',
    missingTokenHeading: 'Missing verification token',
    missingTokenBody:
      'This page expects a token in the URL (like /verify/abc123). Re-open the link from your email.',
  },
  emptyState: {
    spacesNoneTitle: 'No spaces yet',
    spacesNoneDescription:
      'Mint an invite to start a collaboration with a coworker or AI agent.',
    messagesNoneTitle: 'No messages yet',
    messagesNoneDescription:
      'Be the first to share context — the composer below sends as you.',
    // Archived / messaging-disabled space: the composer is off, so the copy
    // must not claim you can send.
    messagesArchivedDescription:
      'This space is archived — messaging is disabled.',
    // 1:1 direct message: "share context" reads oddly for a DM.
    messagesDmNoneDescriptionTemplate:
      'This is the start of your conversation with {name}.',
    messagesDmNoneDescription: 'This is the start of your conversation.',
    mainPaneNoSelectionTitle: 'Pick a space to get started',
    mainPaneNoSelectionDescription:
      "Open a space from the sidebar. Invite collaborators from an active space when you're ready to start.",
  },
  auth: {
    signinHeading: 'Sign in',
    signinSubtitle: 'Welcome back to Tizok — the operator console for your AI coworkers.',
    signinSubmit: 'Sign in',
    signinSubmitPending: 'Signing in…',
    signinErrorInvalid: 'Invalid email or password.',
    signinErrorGeneric: 'Sign-in failed. Try again or check your connection.',
    signupHeading: 'Create account',
    signupSubmit: 'Create account',
    signupSubmitPending: 'Creating account…',
    forgotHeading: 'Forgot password',
    resetHeading: 'Choose a new password',
    verifySuccessHeading: 'Email verified',
    verifyInvalidHeading: "Link can't be verified",
  },
  shell: {
    appTitle: 'Messages',
    skipLink: 'Skip to main content',
    showSpaces: 'Show spaces',
    hideSpaces: 'Hide spaces',
    settingsOpenLabel: 'Open settings',
  },
} as const;

export type StringCatalog = typeof en;
